import { useCallback } from 'react';
import type { PageOrientation } from '../shared/gridConfig';
import { useRepositionBlocksOnOrientationChange } from './useRepositionBlocksOnOrientationChange';
import type { MovedBlock } from '../UndoRedo/UpdateDocumentSettingsCommand';

export function useOrientationChangeHandler(
  previousOrientation: PageOrientation | undefined,
  persist: (orientation: PageOrientation, movedBlocks: MovedBlock[]) => void
) {
  const repositionBlocksOnOrientationChange = useRepositionBlocksOnOrientationChange();

  return useCallback(
    async (orientation: PageOrientation) => {
      const movedBlocks = await repositionBlocksOnOrientationChange(orientation, previousOrientation).catch(() => []);
      persist(orientation, movedBlocks);
    },
    [repositionBlocksOnOrientationChange, previousOrientation, persist]
  );
}
